import React from 'react';
import './index.css';
import Icon from '../../artzu-ui/src/Icon';
import { m } from '../../utils';

const BookingReview = ({ selectedShifts, parkinglotName, tier, removeShiftFromSelection, rate }) => (
  <div className="book-review">
    {selectedShifts.sort((a, b) => a.startTime - b.startTime).map((shift, index) => (
      <div className="shift-panel" key={index}>
        <div className="shift-timing">
          <div><b>{m(shift.date).format('dddd')},</b></div>
          <strong>{m(shift.date).format('MMM Do, YYYY')}</strong>
          <div>
            {m(shift.startTime).format('h A')} to {m(shift.endTime).format('h A')}
          </div>
        </div>
        <div className="shift-tier">
          <strong>{parkinglotName[0].toUpperCase() + parkinglotName.substr(1)}</strong>
          <div>{tier.toUpperCase()}</div>
        </div>
        <div className={rate[tier] > shift.rate ? "shift-rate blueish" : "shift-rate"}>
          ${shift.rate}/hr
        </div>
        <div className="shift-deselect">
          <a href="javascript:void(0)" onClick={() => removeShiftFromSelection(shift.date, shift.startTime, shift.endTime, shift.tier, shift.rate)}>
            <Icon size="xs" name="Close" color="#414141" />
          </a>
        </div>
      </div>
    ))}
  </div>
);

export default BookingReview;



// WEBPACK FOOTER //
// ./src/components/NewBook/BookingReview.js